export default __webpack_public_path__ + "static/media/blankFridge.17761477.jpeg";